/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, disable, mediaQuery } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// FORM : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	form: {
		'&.processing-true': {
			'& .grid, .name-save-changes, .name-discard-changes, .name-cancel': {
				extend: disable
			}
		},
		'&.editable-false': {
			'& .grid, .name-save-changes, .name-discard-changes, .name-cancel': {
				extend: disable
			}
		},

		// grid
		'& .gridset': {
			'& .griditem': {
				marginBottom: pxToEm(20),
				marginRight: pxToEm(20),
				maxWidth: pxToEm(310),
				width: '100%',
				'& .field': {
					maxWidth: pxToEm(310),
					width: '100%'
				},
				'&:last-child': {
					marginRight: '0'
				}
			},
			'&.direction-vertical': {
				'& .griditem': {
					maxWidth: '100%',
					marginRight: '0',
					'& .field': {
						maxWidth: '100%'
					}
				}
			}
		}
	},

	// ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
	[mediaQuery.thinnest]: {
		form: {
			width: '100%',
			'& .gridset': {
				width: '100%',
				'& .griditem': {
					width: '100%',
					maxWidth: '100%',
					marginRight: '0',
					'& .field': {
						minWidth: '100%',
						width: '100%',
						maxWidth: '100%'
					}
				}
			}
		}
	}
});